import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class SecureStorageService {
  private secretKey = 'K-Privilege-Secret-Key'; // In a real app, use a more secure approach

  constructor() {}

  /**
   * Encrypts data and stores it in localStorage
   * @param key Storage key
   * @param data Data to encrypt and store
   */
  setItem(key: string, data: any): void {
    try {
      const dataStr = typeof data === 'object' ? JSON.stringify(data) : String(data);
      const encryptedData = CryptoJS.AES.encrypt(dataStr, this.secretKey).toString();
      localStorage.setItem(key, encryptedData);
    } catch (error) {
      console.error('Error encrypting data:', error);
    }
  }

  /**
   * Retrieves encrypted data from localStorage and decrypts it
   * @param key Storage key
   * @returns Decrypted data or null if error/not found
   */
  getItem(key: string): any {
    try {
      const encryptedData = localStorage.getItem(key);
      if (!encryptedData) return null;
      
      const decryptedData = CryptoJS.AES.decrypt(encryptedData, this.secretKey).toString(CryptoJS.enc.Utf8);
      
      try {
        // Try to parse as JSON first
        return JSON.parse(decryptedData);
      } catch {
        // If not valid JSON, return as string
        return decryptedData;
      }
    } catch (error) {
      console.error('Error decrypting data:', error);
      return null;
    }
  }

  /**
   * Removes item from localStorage
   * @param key Storage key to remove
   */
  removeItem(key: string): void {
    localStorage.removeItem(key);
  }
}